export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtNVModel';
export const NAME = 'ModelNv';

export enum PPalivoEnum {
	BenzinNatural = 1,
	Diesel = 2,
	BenzinOlovnaty = 3,
	PlynLPG = 4,
	Elektro = 5,
	PlynCNG = 6,
}
